export const endpoints = {
    "EVOLUTION_VIEW": "/region/evaluation/view",
    "EVOLUTION_CREATE": "/region/evaluation/variant/create",
    "EVOLUTION_DELETE": "/region/evaluation/variant/delete",
    "EVOLUTION_UPDATE": "/region/evaluation/variant/update",
}